import { MACRO_KEY } from "../../optics/defaults";

export const MACRO_DATA = {
  [MACRO_KEY.NEW_STARTERS]: {
    name: "New starters",
    description: "Introduce new hires and enhance the onboarding process.",
    people: [
      {
        avatarUrl: "/img/widgets/people/person-male-1.png",
        name: "Lucas Rivera",
        subtitle: "Full Stack Developer",
        label: "Jun 1",
        emoji: "🚀",
      },
      {
        avatarUrl: "/img/widgets/people/person-male-2.png",
        name: "Peter Patel",
        subtitle: "Head of Engineering",
        label: "May 15",
        emoji: "🚀",
      },
      {
        avatarUrl: "/img/widgets/people/person-male-3.png",
        name: "Benjamin Stein",
        subtitle: "Operations Coordinator",
        label: "Apr 10",
        emoji: "🚀",
      },
      {
        avatarUrl: "/img/widgets/people/person-male-4.png",
        name: "Noah Kim",
        subtitle: "QA Engineer",
        label: "Apr 1",
        emoji: "🚀",
      },
    ],
  },
  [MACRO_KEY.UPCOMING_BIRTHDAYS]: {
    name: "Upcoming birthdays",
    description: "Stay connected by celebrating upcoming team birthdays.",
    people: [
      {
        avatarUrl: "/img/widgets/people/person-female-1.png",
        name: "Ava Turner",
        subtitle: "Jun 23",
        label: "Today",
        emoji: "🎉",
      },
      {
        avatarUrl: "/img/widgets/people/person-male-5.png",
        name: "Liam Brooks",
        subtitle: "Jun 30",
        label: "7 days",
      },
      {
        avatarUrl: "/img/widgets/people/person-female-2.png",
        name: "Angelica Lorens",
        subtitle: "Jul 01",
        label: "8 days",
      },
      {
        avatarUrl: "/img/widgets/people/person-male-6.png",
        name: "Ethan Cole",
        subtitle: "Jul 05",
        label: "12 days",
      },
    ],
  },
  [MACRO_KEY.WORK_ANNIVERSARY]: {
    name: "Work anniversary",
    description:
      "Stay updated and celebrate work milestones, reinforcing company culture.",
    people: [
      {
        avatarUrl: "/img/widgets/people/person-male-1.png",
        name: "Lucas Rivera",
        subtitle: "5 years",
        label: "Today",
        emoji: "🎁",
      },
      {
        avatarUrl: "/img/widgets/people/person-male-2.png",
        name: "Peter Patel",
        subtitle: "5 years",
        label: "15 days",
      },
      {
        avatarUrl: "/img/widgets/people/person-male-3.png",
        name: "Benjamin Stein",
        subtitle: "2 years",
        label: "20 days",
      },
      {
        avatarUrl: "/img/widgets/people/person-male-4.png",
        name: "Noah Kim",
        subtitle: "3 years",
        label: "22 days",
      },
    ],
  },
};
